<template>
  <div>
    <div class="map-outer">
      <p class="text_center fz12" style="color: #e82c2c; margin: 0 0 20px 0">
        地图标注仅供参考，具体位置以标的物实际为准
      </p>

      <div class="map_w">
        <div class="map_options">
          <el-radio-group v-model="tMapType" size="small">
            <el-radio-button label="Satellite">卫星</el-radio-button>
            <el-radio-button label="Normal">地图</el-radio-button>
          </el-radio-group>
        </div>

        <!-- leaflet地图 -->
        <div id="lMap" style="width: 100%; height: 450px" />

        <!-- 天地图实例 -->
        <div id="tMap" />
      </div>
    </div>
    <!-- 按需引入js资源 -->
    <ImportJs
      :src="`${static_resource}/js/tianditu.js`"
      script-key="tianditu"
    />
    <ImportJs
      :src="`${static_resource}/leaflet/js/leaflet.js`"
      script-key="leaflet"
    />
    <ImportJs
      :src="`${static_resource}/leaflet/js/leaflet-geoman.js`"
      script-key="leaflet-geoman"
    />
    <ImportJs
      :src="`${static_resource}/js/turf.js`"
      script-key="turf"
      @loadComplete="mapJsCompleteFn"
    />

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import {  filterRepeat } from "@/utils";
import ImportJs from "@/components/base/ImportJs.vue";
import providers from "@/assets/js/chinatmsproviders";
import { tMapKey } from "@/utils/setting";

export default {
  props: {
    project: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImportJs,
  },
  data() {
    return {
      lMap: null, //标的位置地图实例
      layerMap: null, // 底图线路
      layerAnnotion: null, //底图文字
      tMap: null,
      geocoder: null,
      allMasterLnglats: [],
      polygonLayers: [],
      masterLayers: [],
      tMapType: "Satellite",
      currentTarget: null, // 当前选中的标的信息
      currZoom: null,
      popupContent: {},
      formatted_address: null,
      currentMasterLayer: null,
      hasTargetLocation: false,
      containerId: "lMap",
      locMaster: null, // 点标记（目前只有一个）

      masterMap: new Map(),
    };
  },
  computed: {
    ...mapGetters(["isMapJsComplete", "static_resource", "transportProtocol"]),
    masterOption() {
      // 点标记默认配置
      return {
        icon: L.icon({
          iconSize: [25, 41],
          iconAnchor: [13, 40],
          iconUrl:
            this.transportProtocol +
            "://api.tianditu.gov.cn/v4.0/image/marker-icon.png",
        }),
      };
    },
    targets() {
      return this.project.targets;
    },
    firstTarget() {
      return this.targets[0];
    },
    masterPopup() {
      return function (name,address) {
        return `<div class="master-popup" style="width: 247px">
      <div class="font_w_bold">${name}</div>
      <div class="fz12" style="color: #b4b4b4; margin: 5px 0 0 0">
        ${address || ''}
      </div>
    </div>`;
      };
    },
  },
  watch: {
    tMapType() {
      this.addTiandituLayer();
    },
    isMapJsComplete: {
      handler(n) {
        if (n) {
          providers(L);
          this.$nextTick(() => {
            this.createlMap();
            this.addTiandituLayer();
            this.initTargetLocation();
            this.initTMap();
          });
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    ...mapMutations({
      mapJsCompleteFn: "app/mapJsCompleteFn",
    }),
    // 初始天地图实例
    initTMap() {
      this.tMap = new T.Map(this.containerId);
      this.geocoder = new T.Geocoder();
    },
    // 创建地图实例
    createlMap() {
      this.lMap = new L.map(this.containerId, {
        center: [this.firstTarget.gpsLat, this.firstTarget.gpsLng], //默认定位北京
        zoom: 12,
        minZoom: 5,
        maxZoom: 18,
        zoomControl: false,
        attributionControl: false,
      });
    },
    // 添加天地图瓦片
    addTiandituLayer() {
      //先移除原来的底图，否则会叠加
      this.layerMap?.remove();
      this.layerAnnotion?.remove();
      this.layerMap = L.tileLayer
        .chinaProvider(`TianDiTu.${this.tMapType}.Map`, {
          key: tMapKey,
        })
        .addTo(this.lMap); // 线路
      this.layerAnnotion = L.tileLayer
        .chinaProvider(`TianDiTu.${this.tMapType}.Annotion`, {
          key: tMapKey,
        })
        .addTo(this.lMap); // 文字
    },
    // 初始标的位置
    async initTargetLocation() {
      this.createMasterByTargets();
      this.createPolygonByTargets();
      this.setMapBoundsByTargets()
    },
    // 定位点标记
    flyToMaster(latlng) {
      this.lMap.flyTo(latlng, 18, {
        duration: 2,
        noMoveStart: true,
      });
    },
    // 根据标的物创建点标记
    createMasterByTargets() {
      let master = null;
      this.targets.forEach(async (v) => {
        master = await this.createMaster(
          await this.getLngLat(v.gpsLng, v.gpsLat),
          this.masterOption
        );
        this.masterMap.set(v.id, master);
        this.addCoverToMap(master);
        this.createPopup(v,master)
        master.addEventListener("click", (e) => {
          if (this.lMap.getZoom() < 18) {
            this.flyToMaster(e.latlng);
          }
        });
      });
    },
    // 根据标的物创建多边形
    createPolygonByTargets() {
      for (let target of this.targets) {
        if(target.layer){
          this.createPolygonByLngLats(JSON.parse(target.layer));
        }
      }
    },
    // 设置地图边界
    async setMapBoundsByTargets(){
      let bounds = []
      for (let v of this.targets) {
        bounds.push(await this.getLngLat(v.gpsLng, v.gpsLat))
      }
      this.lMap.fitBounds(bounds)
    },

    // 获取经纬度实例 lng:经度 lat:纬度
    getLngLat(lng, lat) {
      return new T.LngLat(lng, lat);
    },
    // 创建点标记
    createMaster(lnglat, option) {
      return L.marker(lnglat, option);
    },
    // 添加覆盖物
    addCoverToMap(cover) {
      cover.addTo(this.lMap);
    },
    // 根据经纬度创建多边形
    createPolygonByLngLats(lnglats) {
      for (let v of lnglats) {
        L.polygon(v).addTo(this.lMap);
      }
    },
    // 添加弹出窗口
    createPopup(target, master) {
      master.bindPopup(this.masterPopup(target.name,target.address),{
          offset: L.point(0, -30),
          closeButton: false,
        }).openPopup()
    },
  },
};
</script>

<style lang="scss" scoped>
.map-outer {
}
.map_w {
  position: relative;
  .map_options {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 401;
    ::v-deep .el-radio-button__inner {
      border-radius: 0;
    }
  }
}
</style>